webpackJsonp([35783957827783],{

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RedirectPage = function (_React$Component) {
	  _inherits(RedirectPage, _React$Component);
	
	  function RedirectPage() {
	    _classCallCheck(this, RedirectPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  RedirectPage.prototype.componentDidMount = function componentDidMount() {
	    this.props.history.push('/en');
	  };
	
	  RedirectPage.prototype.render = function render() {
	    return null;
	  };
	
	  return RedirectPage;
	}(_react2.default.Component);
	
	RedirectPage.propTypes = {
	  history: _propTypes2.default.shape({
	    push: _propTypes2.default.func.isRequired
	  }).isRequired
	};
	
	exports.default = RedirectPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-2b39b84a9b491fc4f4e0.js